export default __webpack_public_path__ + "static/media/fundingcard.b65d96a5.jpg";